import { render, staticRenderFns } from "./UblToPurchaseModal.vue?vue&type=template&id=76bfcc3f&scoped=true"
import script from "./UblToPurchaseModal.vue?vue&type=script&lang=ts"
export * from "./UblToPurchaseModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfcc3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76bfcc3f')) {
      api.createRecord('76bfcc3f', component.options)
    } else {
      api.reload('76bfcc3f', component.options)
    }
    module.hot.accept("./UblToPurchaseModal.vue?vue&type=template&id=76bfcc3f&scoped=true", function () {
      api.rerender('76bfcc3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/UblToPurchaseModal.vue"
export default component.exports